import React from "react";
import { Table } from "rsuite";

const { Cell } = Table;

export default function DetailActionTableCell({ rowData, ...props }) {
  return (
    <Cell {...props}>
      {`${
        rowData.Roles && rowData.Roles.find((r) => r.Id === 6)
          ? rowData.Roles.find((r) => r.Id === 6).Name
          : rowData.Roles && rowData.Roles.find((r) => r.Id === 8)
          ? rowData.Roles.find((r) => r.Id === 8).Name
          : ""
      }`}
    </Cell>
  );
}
